import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addContratista, addEmpresa, editContratista, editEmpresa, getCIIU } from "../../../../../../../redux/actions/resolucion";
import { StyledResolucion } from "../../../../../../styled/Prevencion";
import DialogComponent from "./DialogComponent";
import TableComponent from "./TableComponent";

const ContratistasYEmpresasContainer = ({
}) => {
  const dispatch = useDispatch();

  const contratistas = useSelector((state) => state.resolucion.contratistas);
  const empresas = useSelector((state) => state.resolucion.empresas);
  const [openDialogContratista, setOpenDialogContratista] = useState(false);
  const [openDialogEmpresa, setOpenDialogEmpresa] = useState(false);
  const [editData, setEditData] = useState(null);

  useEffect(() => {
    dispatch(getCIIU());
  }, []);

  // Métodos para abrir y cerrar diálogos
  const handleOpenContratistaDialog = (data = null) => {
    setEditData(data);
    setOpenDialogContratista(true);
  };

  const handleOpenEmpresaDialog = (data = null) => {
    setEditData(data);
    setOpenDialogEmpresa(true);
  };

  const handleCloseDialog = () => {
    setEditData(null);
    setOpenDialogContratista(false);
    setOpenDialogEmpresa(false);
  };

  const handleSubmitContratista = (values) => {
    dispatch(addContratista(values));
  };

  const handleSubmitEmpresa = (values) => {
    dispatch(addEmpresa(values));
  };

  const handleEditContratista = (values) => {
    dispatch(editContratista(values));
  };

  const handleEditEmpresas = (values) => {
    dispatch(editEmpresa(values));
  };

  return (
    <>
      <StyledResolucion.Container>

        <>
          <Grid container spacing={2}>
            <Grid item xs={12} xl={6}>
              <TableComponent
                onAdd={() => handleOpenContratistaDialog()}
                onEdit={handleOpenContratistaDialog}
                data={contratistas.data}
                title="Contratista"
              />
            </Grid>
            <Grid item xs={12} xl={6}>
              <TableComponent
                onAdd={() => handleOpenEmpresaDialog()}
                onEdit={handleOpenEmpresaDialog}
                data={empresas.data}
                title="Empresa Tercerizada"
              />
            </Grid>
          </Grid>
          {/* Diálogos */}
          <DialogComponent
            open={openDialogContratista}
            onClose={handleCloseDialog}
            onSubmit={handleSubmitContratista}
            onEdit={handleEditContratista}
            editData={editData}
            title="Contratista"
          />
          <DialogComponent
            open={openDialogEmpresa}
            onClose={handleCloseDialog}
            onSubmit={handleSubmitEmpresa}
            onEdit={handleEditEmpresas}
            editData={editData}
            title="Empresa Tercerizada"
          />
        </>

      </StyledResolucion.Container>

    </>
  );
};

export default ContratistasYEmpresasContainer;
